export type ThemeName = 'dark' | 'light';

export const THEME_STORAGE_KEY = 'luacentrix.theme';

export const THEME_ORDER: Array<ThemeName> = ['dark', 'light'];

const THEME_COLORS: Record<ThemeName, string> = {
  dark: '#000000',
  light: '#ffffff',
};

const THEME_SWITCH_MS = 360;

let themeSwitchTimer = 0;

function storedTheme(): ThemeName | null {
  try {
    const value = window.localStorage.getItem(THEME_STORAGE_KEY);
    return value === 'dark' || value === 'light' ? value : null;
  } catch {
    return null;
  }
}

export function readTheme(): ThemeName {
  return storedTheme() ?? 'dark';
}

export function applyTheme(theme: ThemeName): void {
  const root = document.documentElement;
  root.dataset.theme = theme;
  root.dataset.themeSwitch = '1';
  root.style.colorScheme = theme;
  window.clearTimeout(themeSwitchTimer);
  themeSwitchTimer = window.setTimeout(() => {
    delete root.dataset.themeSwitch;
  }, THEME_SWITCH_MS);
  const meta = document.querySelector('meta[name="color-scheme"]');
  if (meta !== null) meta.setAttribute('content', theme);
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor !== null) themeColor.setAttribute('content', THEME_COLORS[theme]);
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    return;
  }
}

export function otherTheme(theme: ThemeName): ThemeName {
  return theme === 'dark' ? 'light' : 'dark';
}
